import styled from "styled-components"

export const StyledUserPanelAnnouncements = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    align-items: ${({ $centerItems }) => $centerItems ? "center" : "stretch"};

    @media only screen and (max-width: 926px){
        padding: 0 20px;

        h2{
            font-size: 32px;
            padding: 40px 0 10px;
        }
    }

    @media only screen and (max-width: 350px){
        h2{
            font-size: 28px;
        }
    }
`

export const StyledScrollWrapper = styled.div`
    margin-top: 8px;
    overflow-y: scroll;
    height: calc(100% - 60px);
    padding-right: 15px;

    scrollbar-color: ${({ $isscrollbar }) =>
        $isscrollbar ? "#6786be rgba(103, 134, 190, 0.3)" : "transparent transparent"};
    scrollbar-width: ${({ $isscrollbar }) => ($isscrollbar ? "thin" : "none")};

    ::-webkit-scrollbar {
        height: 6px;
    }
    ::-webkit-scrollbar-track {
        border-radius: 6px;
        background: ${({ $isscrollbar }) =>
            $isscrollbar ? "rgba(103, 134, 190, 0.3)" : "transparent"};
    }
    ::-webkit-scrollbar-thumb {
        background: #6786be;
        border-radius: 6px;
    }

    @media only screen and (max-width: 926px){
        padding-right: 0;
        overflow-y: visible;
        height: auto;
        width: 100%;
    }
`